import { render, staticRenderFns } from "./PoultryManagement.vue?vue&type=template&id=2c5bc74c&scoped=true&lang=html&"
import script from "./PoultryManagement.vue?vue&type=script&lang=js&"
export * from "./PoultryManagement.vue?vue&type=script&lang=js&"
import style0 from "./PoultryManagement.vue?vue&type=style&index=0&id=2c5bc74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5bc74c",
  null
  
)

export default component.exports